export default __webpack_public_path__ + "static/media/back.df7f5256.svg";